import { API_CLOSE_STICKY_BANNER } from "src/consts/urls";
import { useMutation } from "src/hooks/react-query/use-mutation";

export const useCloseStickyBannerMutation = () => useMutation(API_CLOSE_STICKY_BANNER);
